import { useEffect } from "react";

export type PlatformShortcut = {
    key: string;
    mac?: string;
    windows?: string;
};

export type Command = {
    label: string;
    shortcut: PlatformShortcut;
    onClick: () => void;
};

const isMac = () => navigator.platform.toUpperCase().indexOf("MAC") >= 0;

export const getShortcutDisplay = (shortcut: PlatformShortcut): string => {
    if (isMac() && shortcut.mac) {
        return shortcut.mac;
    }
    if (!isMac() && shortcut.windows) {
        return shortcut.windows;
    }
    return shortcut.key;
};

const getModifierKey = (e: KeyboardEvent): boolean => {
    return isMac() ? e.metaKey : e.ctrlKey;
};

export function useHotkey({ command }: { command?: Command }) {
    useEffect(() => {
        if (command) {
            const handleKeyDown = (e: KeyboardEvent) => {
                const modifierKey = getModifierKey(e);
                const key = command.shortcut.key.toLowerCase();

                if (modifierKey && e.key.toLowerCase() === key) {
                    e.preventDefault();
                    command.onClick();
                }
            };

            document.addEventListener("keydown", handleKeyDown);
            return () => document.removeEventListener("keydown", handleKeyDown);
        }
    }, [command]);
}
